import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Icon } from 'shared/components';

import theme from './AllowCameraPlaceholder.scss';

const AllowCameraPlaceholder = () => (
  <div className={ theme.root }>
    <FormattedMessage id="conference.askUserToUseWebcam" defaultMessage="** Allow 'Online Doctor' to use your camera and microphone" />
    <Icon name="video-mic-permissions" />
  </div>
);

export default injectIntl(AllowCameraPlaceholder);
